interface TelegramIconProps {
  color?: string;
  className?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function TelegramIcon({ className, color = 'white' }: TelegramIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="m22 2-7 20-4-9-9-4Z" />
      <path d="M22 2 11 13" />
    </svg>
  );
}
